import LatestVideo from './LatestVideo';

export default LatestVideo;
